import type { ReactNode, ComponentType } from 'react';

type TScreensMap = Record<string, ComponentType>;
type TNamedContainers = Record<string, ReactNode>;

/** Конвертировать camelCase в UPPER_CASE */
const convertToUpperCase = (text: string): string =>
    text.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();

/** Подготовить карту экранов для виджета Confirmation  */
export const prepareScreensMap =
    (namedContainers: TNamedContainers) => (screensMap: TScreensMap) => ({
        ...screensMap,
        ...Object.entries(namedContainers).reduce(
            (acc, [key, node]) => ({
                ...acc,
                [convertToUpperCase(key)]: () => node,
            }),
            {}
        ),
    });
